// PHA-1293: patient_id is Phanova's internal key. It equals the clinic's MRN, except for a
// patient whose MRN was already another clinic's patient_id: that one is created as
// "<mrn>|<n>" (backend _new_internal_patient_id / is_patient_id_available_for_user). The
// clinic only knows the MRN, so anything shown to a clinician as "MRN" goes through here.
// An MRN never contains "|", so stripping the suffix always gives back the stored MRN.
const INTERNAL_SUFFIX = /^([^|]+)\|\d+$/;

export function displayMrn(patientId: string | null | undefined): string {
  const id = String(patientId ?? '');
  const m = id.match(INTERNAL_SUFFIX);
  return m ? m[1] : id;
}

/** The id the server actually created/holds, falling back to what was typed. */
export function createdPatientId(result: any, typedMrn: string): string {
  const id = String(result?.patient_id ?? '').trim();
  return id || typedMrn;
}
